import type { MerchantScheduleData } from '@/modules/stores/types/get-merchant-details';

/**
 * Calcula o próximo horário de abertura da loja
 */
export function getNextOpeningTime(scheduleData: MerchantScheduleData): string | undefined {
  if (!scheduleData) return undefined;

  const now = new Date();
  const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
  
  // Mapear dias da semana para o formato da API
  const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  
  // Verificar os próximos 7 dias
  for (let i = 0; i < 7; i++) {
    const dayIndex = (currentDay + i) % 7;
    const dayName = dayMap[dayIndex] as keyof MerchantScheduleData;
    const daySchedule = scheduleData[dayName];
    
    if (daySchedule && daySchedule.length > 0) {
      const firstSchedule = daySchedule[0];
      
      if (i === 0) {
        // Hoje - verificar se ainda não passou do horário
        const [hours, minutes] = firstSchedule.open.split(':').map(Number);
        const openTime = new Date();
        openTime.setHours(hours, minutes, 0, 0);
        
        if (now < openTime) {
          return `hoje às ${firstSchedule.open}`;
        }
      } else {
        // Próximos dias
        const dayNames = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
        return `${dayNames[dayIndex]} às ${firstSchedule.open}`;
      }
    }
  }
  
  return undefined;
}

/**
 * Verifica se a loja deveria estar aberta baseado no horário atual e schedule_data
 */
export function shouldStoreBeOpen(scheduleData: MerchantScheduleData): boolean {
  if (!scheduleData) return false;

  const now = new Date();
  const currentDay = now.getDay();
  const currentTime = now.getHours() * 60 + now.getMinutes(); // minutos desde meia-noite
  
  const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const dayName = dayMap[currentDay] as keyof MerchantScheduleData;
  const daySchedule = scheduleData[dayName];
  
  if (!daySchedule || daySchedule.length === 0) return false;
  
  // Verificar se está dentro de algum horário de funcionamento
  for (const schedule of daySchedule) {
    const [openHours, openMinutes] = schedule.open.split(':').map(Number);
    const [closeHours, closeMinutes] = schedule.close.split(':').map(Number);
    
    const openTime = openHours * 60 + openMinutes;
    const closeTime = closeHours * 60 + closeMinutes;
    
    // Lidar com horários que passam da meia-noite (ex: 23:00 - 02:00)
    if (closeTime < openTime) {
      if (currentTime >= openTime || currentTime <= closeTime) {
        return true;
      }
    } else {
      if (currentTime >= openTime && currentTime <= closeTime) {
        return true;
      }
    }
  }
  
  return false;
}
